import axios from "axios"
import { useEffect, useState } from "react"

export default function useIsTest(){
  const [isTest, setIsTest] = useState(false)

  useEffect(() => {
    async function getIsTest(){
        try {
            const response = await axios.get("/api/v1/is-test");
            const isTest = response.data;
            setIsTest(isTest)
        } catch (error) {
            setIsTest(false)
            console.error(error)
        }
    }
    getIsTest()
  }, [])

  return isTest
}
